import { useQuery } from '@tanstack/react-query';
import { pnidApi } from '../api';
import { queryKeys } from '../queries/keys';

const LINE_SUGGESTION_LIMIT = 20;

/** Line numbers the drawing's plant already carries that match `query`, best match first. */
export function useLineSuggestions(docId: string, query: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.lineSuggestions(docId, query),
    queryFn: ({ signal }) => pnidApi.getLineSuggestions(docId, query, LINE_SUGGESTION_LIMIT, signal),
    enabled: enabled && Boolean(docId),
  });
}
